// ProtectedRoute.js
import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const userData = sessionStorage.getItem("userData");

  // If no user data found, redirect to login
  if (!userData) 
    {
    return <Navigate to="/login"
     replace 
     />;
  }

  // Otherwise, render the protected component
  return children;
};

export default ProtectedRoute;
